import { useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { getMessages } from 'components/Modal/SendMessages/actions';
import { downloadAttachedFile } from '../actions';

const useCandidates = (candidateId: string | number | undefined) => {
  const dispatch = useDispatch();
  const downloadAttachedFileHandler = useCallback(
    (type: string, id: string | number) => () => dispatch(downloadAttachedFile({ type, id })),
    [dispatch]
  );

  const getMessagesHandler = useCallback(() => dispatch(getMessages({ candidateId })), [
    candidateId,
    dispatch,
  ]);

  useEffect(() => {
    getMessagesHandler();
  }, [getMessagesHandler]);

  return { downloadAttachedFileHandler };
};

export default useCandidates;
